<template>
  <Select
    :items="fornecedores"
    :selectedItem="selectedItem"
    label="Fornecedor"
    searchPlaceholder="Buscar fornecedor"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../mixins/Select.js';

export default {
  mixins: [Select],
  data() {
    return {
      fornecedores: [],
    }
  },
  mounted() {
    this.$api.get('/stakeholders/busca_todos', { params: { tipo: "fornecedor" } }).then(({ data }) => {
      this.fornecedores = data.map(fornecedor => ({
        id: fornecedor.id,
        name: fornecedor.label,
      }));

      const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
      this.$renderFiltroSelect(filtroAplicado, this.fornecedores, this.selectedItem);
    });
  },
}
</script>